import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const responseSchema = z.object({
  profile_has_amazon_ads_api_access: z.boolean(),
  amazon_ads_api_authorized_by: z.string().nullable(),
  amazon_ads_api_authorized_on: z.string().nullable(),
});

export const amazonAdsConnectionStatusDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getCurrentProfileAmazonAdsConnectionStatus",
    method: "get",
    path: "/current_profile_amazon_ads_api_connection_status/",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: responseSchema,
  }).build(),
);
